<div class="flex-1 min-h-0 overflow-hidden">
  <router-outlet />
</div>
